export const ADD_SELLITEM = "ADD_SELLITEM";
export const ADD_SELLITEM_SUCCESS = "ADD_SELLITEM_SUCCESS";
export const ADD_SELLITEM_FAIL = "ADD_SELLITEM_FAIL";

export const GET_ALL_SELLITEM = "GET_ALL_SELLITEM";
export const GET_ALL_SELLITEM_SUCCESS = "GET_ALL_SELLITEM_SUCCESS";
export const GET_ALL_SELLITEM_FAIL = "GET_ALL_SELLITEM_FAIL";

export const GET_PARTICULAR_SELLITEM = "GET_PARTICULAR_SELLITEM";
export const GET_PARTICULAR_SELLITEM_SUCCESS =
  "GET_PARTICULAR_SELLITEM_SUCCESS";
export const GET_PARTICULAR_SELLITEM_FAIL = "GET_PARTICULAR_SELLITEM_FAIL";

export const UPDATE_PARTICULAR_SELLITEM = "UPDATE_PARTICULAR_SELLITEM";
export const UPDATE_PARTICULAR_SELLITEM_SUCCESS =
  "UPDATE_PARTICULAR_SELLITEM_SUCCESS";
export const UPDATE_PARTICULAR_SELLITEM_FAIL =
  "UPDATE_PARTICULAR_SELLITEM_FAIL";

export const SELLITEM_FROM_COLLECTION_ID = "SELLITEM_FROM_COLLECTION_ID";
export const SELLITEM_FROM_COLLECTION_ID_SUCCESS =
  "SELLITEM_FROM_COLLECTION_ID_SUCCESS";
export const SELLITEM_FROM_COLLECTION_ID_FAIL =
  "SELLITEM_FROM_COLLECTION_ID_FAIL";

export const LIKE_VIEW_SELLITEM = "LIKE_VIEW_SELLITEM";
export const LIKE_VIEW_SELLITEM_SUCCESS = "LIKE_VIEW_SELLITEM_SUCCESS";
export const LIKE_VIEW_SELLITEM_FAIL = "LIKE_VIEW_SELLITEM_FAIL";

export const ALL_SELLITEM_FROM_COLLECTION_ID =
  "ALL_SELLITEM_FROM_COLLECTION_ID";
export const ALL_SELLITEM_FROM_COLLECTION_ID_SUCCESS =
  "ALL_SELLITEM_FROM_COLLECTION_ID_SUCCESS";
export const ALL_SELLITEM_FROM_COLLECTION_ID_FAIL =
  "ALL_SELLITEM_FROM_COLLECTION_ID_FAIL";

export const ALL_SELLITEM_NFT_COUNT = "ALL_SELLITEM_NFT_COUNT";
export const ALL_SELLITEM_NFT_COUNT_SUCCESS = "ALL_SELLITEM_NFT_COUNT_SUCCESS";
export const ALL_SELLITEM_NFT_COUNT_ID_FAIL = "ALL_SELLITEM_NFT_COUNT_ID_FAIL";

export const SELL_ITEM_CURRENT_OWNER = "SELL_ITEM_CURRENT_OWNER";
export const SELL_ITEM_CURRENT_OWNER_SUCCESS =
  "SELL_ITEM_CURRENT_OWNER_SUCCESS";
export const SELL_ITEM_CURRENT_OWNER_FAIL = "SELL_ITEM_CURRENT_OWNER_FAIL";

export const TOP_SELL_ITEM = "TOP_SELL_ITEM";
export const TOP_SELL_ITEM_SUCCESS = "TOP_SELL_ITEM_SUCCESS";
export const TOP_SELL_ITEM_FAIL = "TOP_SELL_ITEM_FAIL";

export const TRENDING_ARTWORK = "TRENDING_ARTWORK";
export const TRENDING_ARTWORK_SUCCESS = "TRENDING_ARTWORK_SUCCESS";
export const TRENDING_ARTWORK_FAIL = "TRENDING_ARTWORK_FAIL";

export const GET_RECENT_LISTING = "GET_RECENT_LISTING";
export const GET_RECENT_LISTING_SUCCESS = "GET_RECENT_LISTING_SUCCESS";
export const GET_RECENT_LISTING_FAIL = "GET_RECENT_LISTING_FAIL";

export const GET_EXPLORE_LISTING = "GET_EXPLORE_LISTING";
export const GET_EXPLORE_LISTING_SUCCESS = "GET_EXPLORE_LISTING_SUCCESS";
export const GET_EXPLORE_LISTING_FAIL = "GET_EXPLORE_LISTING_FAIL";

export const GET_CANVAS_PAPER_SIZE = "GET_CANVAS_PAPER_SIZE";
export const GET_CANVAS_PAPER_SIZE_SUCCESS = "GET_CANVAS_PAPER_SIZE_SUCCESS";
export const GET_CANVAS_PAPER_SIZE_FAIL = "GET_CANVAS_PAPER_SIZE_FAIL";
